export const DETECT_INTERVAL = 10;

export const VIDEO_SIZE = {
  width: 320,
  height: 240,
};

export const DRAWING_COLOR = 'aqua';
